







































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { Ability } from '@/types/Ability'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import PhoneInput from '@/components/Tools/PhoneInput.vue'
import Back from '@/components/Tools/Back.vue'
import _ from 'lodash'
import { ConcourInterface } from '@/types/Concour'
import ErrorDisplay from '@/components/ErrorDisplay.vue'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id']),
        ...mapState('concour', ['concours'])
    },
    components: {
        ErrorDisplay,
        ExaGenericTable,
        FontAwesomeIcon,
        PhoneInput,
        Back
    }
})
export default class AccesResutats extends Vue {
    Ability = Ability

    sortBy = ''
    sortDesc = false
    sortDirection = 'asc'
    filterOn = []
    stickyHeader = true
    filtres: any = []
    dataForTab: Array<any> = []
    genericfields = [
        { key: 'user.name', label: 'Utilisateur', sortable: true, class: '', type: 'text' },
        { key: 'concours', label: 'Concours', sortable: false, class: '', type: 'text' },
        { key: 'abilities', label: 'Permissions', sortable: false, class: '', type: 'text' },
        { key: 'delete', label: '', sortable: false, class: '', type: 'action' }
    ]

    showUpdateUser = false
    showSearchContact = false
    showNewContact = false
    showSendMail = false
    mailTo = ''
    mailToOverflow = false
    timeoutBtnMailTo: any = null
    recherche = ''
    search_results: Array<any> = []
    newUser: any = {
        civility: null,
        name: null,
        first_name: null,
        email: null,
        telephone: null,
        telephone_fixe: null
    }

    user_select: any = null
    concour_select = null
    liste_concours: Array<ConcourInterface> = []

    selectedIntervenant = ''

    @Watch('barres_actives')
    getTableauConcours() {
        this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
    }

    // Création des lignes du tableau
    setDataForGenericTab(poData: any, isLoadMore = false) {
        if (!isLoadMore) {
            this.dataForTab = []
        }
        if (poData) {
            for (const result of poData) {
                const line = [{}]
                this.dataForTab.push(line)
            }
        }
    }

    // Initialisation des filtres
    async setFiltersForGenericTab() {
        this.filtres = [
            {
                libelle: 'Utilisateur',
                defautOptionlibelle: 'Rechercher un',
                model: 'user.name',
                value: '',
                index: 'name',
                datas: null,
                loading: false,
                options: { type: 'form', fieldsKey: 'user.name' }
            },
            {
                libelle: 'Concours',
                defautOptionlibelle: 'Rechercher un',
                model: 'concours',
                value: '-',
                index: '',
                datas: this.liste_concours,
                loading: false,
                options: { type: 'deroulant', fieldsKey: 'concours' }
            }
        ]
    }

    // Evenements du tableau
    handleTableEvent(paParams: any): void {
        if (paParams && paParams[0] && paParams[1]) {
            switch (paParams[0]) {
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break
                case 'filterHandler':
                    this.filtreSortHandler(paParams[1])
                    break
                case 'onLoadPage':
                    this.loadHandler(paParams[1])
                    break
            }
        }
    }

    // Chargement des résultats
    loadHandler(params: any) {
        console.log(params)
    }

    // Applique les filtres
    filtreSortHandler(params: any) {
        console.log(params)
    }

    async openSendMail() {
        // TODO: Récupérer les emails des utilisateurs
        // this.mailTo = this.list_users.map((user: any) => user.email).join(';')
        // this.mailToOverflow = this.mailTo.length > 1800

        await this.$nextTick()
        this.showSendMail = true
    }

    closeSendMail() {
        this.showSendMail = false
        this.mailTo = ''
        this.mailToOverflow = false

        if (this.timeoutBtnMailTo) {
            clearTimeout(this.timeoutBtnMailTo)
            this.timeoutBtnMailTo = null
        }
    }

    sendMail() {
        if (this.mailToOverflow) {
            navigator.clipboard.writeText(this.mailTo)

            const button: any = document.getElementById('send-mail')
            if (button) {
                button.innerHTML = 'Copié !'
                this.timeoutBtnMailTo = setTimeout(() => {
                    button.innerHTML = 'Copier'
                }, 3000)
            }
        } else {
            window.open(`mailto:${this.mailTo}`, '_self')
        }
    }

    // Ouvre la popup pour créer un utilisateur
    add_user() {
        this.showUpdateUser = true
    }

    // Ferme la popup d'ajout / edition d'un utilisateur
    cancel_update_user() {
        this.showUpdateUser = false
    }

    // Annule le choix de sélection ou création
    cancel_create_contact() {
        this.showNewContact = false
        this.showSearchContact = false
    }

    // Affiche le formulaire de recherche d'un utilisateur existant
    affiche_search_contact() {
        this.recherche = ''
        this.showSearchContact = true
        this.showNewContact = false
    }

    // TODO : Lance la recherche d'un utilisateur existant
    // -> Cabler l'appel pour la recherche d'un utilisateur
    launch_search() {
        this.selectedIntervenant = ''
        const data = {
            payload: { name: this.recherche + '%' }
        }
        this.$store.dispatch('affectationResponsable/getUsersFromSearch', data).then(() => {
            this.search_results = this.$store.state.affectationResponsable.usersFromSearch.data
        })
    }

    // Affiche le formulaire de création d'un nouvel utilisateur
    affiche_create_contact() {
        this.showSearchContact = false
        this.showNewContact = true
    }

    // Met à jour la valeur locale du numéro de téléphone saisi retourné par le composant PhoneInput
    updatePhoneNumberInputData() {
        if (this.$refs.phoneInput as any) {
            if ((this.$refs.phoneInput as any).infosPhoneInput) {
                if ((this.$refs.phoneInput as any).infosPhoneInput.isValidatedPhoneNumber) {
                    this.newUser.telephone = (this.$refs.phoneInput as any).infosPhoneInput.formattedPhoneNumber
                } else {
                    this.newUser.telephone = ''
                }
            }
        }

        if (this.$refs.phoneFixeInput as any) {
            if ((this.$refs.phoneFixeInput as any).infosPhoneInput) {
                if ((this.$refs.phoneFixeInput as any).infosPhoneInput.isValidatedPhoneNumber) {
                    this.newUser.telephone_fixe = (
                        this.$refs.phoneFixeInput as any
                    ).infosPhoneInput.formattedPhoneNumber
                } else {
                    this.newUser.telephone_fixe = ''
                }
            }
        }
    }

    // Enregistre le nouvel utilisateur
    save_new_user() {
        this.updatePhoneNumberInputData()
        const data: any = {
            civility: this.newUser.civility,
            name: this.newUser.name,
            first_name: this.newUser.first_name,
            email: this.newUser.email,
            telephone: this.newUser.telephone,
            telephone_fixe: this.newUser.telephone_fixe
        }
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)

        this.$store.dispatch('user/addUser', data)
            .then((response) => {
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistrement terminé !', succesToaster)

                // Passage à l'étape 2 - Sélection des concours et permissions
                this.user_select = response.data.data
                this.user_select.concours = []
                this.user_select.abilities = []
                this.reinit_user()
            })
            .finally(() => {
                this.$bvToast.hide(idInfo)
            })
    }

    // Réinitialise la sélection / création d'un utilisateur
    reinit_user() {
        this.showNewContact = false
        this.showSearchContact = false
        this.recherche = ''
        this.newUser = {
            civility: null,
            name: null,
            first_name: null,
            email: null,
            telephone: null,
            telephone_fixe: null
        }
    }

    // Ajoute un concours à la collection de l'utilisateur
    add_concours() {
        if(this.user_select.concours === null) {
            this.user_select.concours = []
        }
        this.user_select.concours.push(this.concour_select)
        this.concour_select = null
    }

    // Retire un concours de la collection de l'utilisateur
    delete_concours(index: number) {
        this.user_select.concours.splice(index, 1)
    }

    // TODO:  Enregistre les concours et les permissions d'un user_select
    // -> Cabler l'enregistrement des permissions et concours
    save_permissions_concours() {
        console.log(this.user_select)

        /*
        const data: any = {
            id : this.user_select.id,
            civility : this.user_select.civility,
            name : this.user_select.name,
            first_name : this.user_select.first_name,
            email : this.user_select.email,
            telephone : this.user_select.telephone,
            telephone_fixe : this.user_select.telephone_fixe,
            abilities : this.user_select.abilities,
            concours : this.user_select.concours
        }

        this.$store.dispatch('centre/addDossierUser', data).then(() => {

        })

        */
    }

    // Ouvre le formulaire d'édition des informations de l'utilisateur
    edit_user() {
        this.newUser = this.user_select
        this.showNewContact = true
    }

    mounted() {
        this.$store.dispatch('concour/getConcoursActifs').then(() => {
            this.liste_concours = _.orderBy(
                this.$store.state.concour.concours.filter((c: any) => c.banque_id !== null),
                'name',
                'asc'
            )
            this.setFiltersForGenericTab()
        })
    }
}
